var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21625_31262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8957 8.4375C48.2942 8.4375 56.3487 11.7738 62.2874 17.7125C68.226 23.6511 71.5623 31.7056 71.5623 40.1042C71.5623 48.5027 68.226 56.5572 62.2874 62.4959C56.3487 68.4345 48.2942 71.7708 39.8957 71.7708C31.4971 71.7708 23.4426 68.4345 17.504 62.4959C11.5653 56.5572 8.229 48.5027 8.229 40.1042C8.229 31.7056 11.5653 23.6511 17.504 17.7125C23.4426 11.7738 31.4971 8.4375 39.8957 8.4375Z",
    fill: "url(#paint0_radial_21625_31262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8956 10.0374C31.9214 10.0374 24.2738 13.2051 18.6352 18.8437C12.9966 24.4823 9.82891 32.1299 9.82891 40.1041C9.82891 48.0782 12.9966 55.7258 18.6352 61.3644C24.2738 67.003 31.9214 70.1707 39.8956 70.1707C47.8697 70.1707 55.5173 67.003 61.1559 61.3644C66.7945 55.7258 69.9622 48.0782 69.9622 40.1041C69.9622 32.1299 66.7945 24.4823 61.1559 18.8437C55.5173 13.2051 47.8697 10.0374 39.8956 10.0374ZM16.3725 16.581C22.6112 10.3423 31.0727 6.8374 39.8956 6.8374C48.7184 6.8374 57.1799 10.3423 63.4186 16.581C69.6574 22.8197 73.1622 31.2812 73.1622 40.1041C73.1622 48.9269 69.6574 57.3884 63.4186 63.6272C57.1799 69.8659 48.7184 73.3707 39.8956 73.3707C31.0727 73.3707 22.6112 69.8659 16.3725 63.6272C10.1338 57.3884 6.62891 48.9269 6.62891 40.1041C6.62891 31.2812 10.1338 22.8197 16.3725 16.581Z",
    fill: "url(#paint1_radial_21625_31262)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0669 34.8959C35.0669 34.0122 35.7832 33.2959 36.6669 33.2959H40.0002C40.8839 33.2959 41.6002 34.0122 41.6002 34.8959V54.2709C41.6002 55.1546 40.8839 55.8709 40.0002 55.8709C39.1166 55.8709 38.4002 55.1546 38.4002 54.2709V36.4959H36.6669C35.7832 36.4959 35.0669 35.7796 35.0669 34.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0669 54.8959C35.0669 54.0122 35.7832 53.2959 36.6669 53.2959H43.3336C44.2172 53.2959 44.9336 54.0122 44.9336 54.8959C44.9336 55.7796 44.2172 56.4959 43.3336 56.4959H36.6669C35.7832 56.4959 35.0669 55.7796 35.0669 54.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1666 26.4959C39.8201 26.4959 40.3499 25.9661 40.3499 25.3126C40.3499 24.659 39.8201 24.1292 39.1666 24.1292C38.513 24.1292 37.9832 24.659 37.9832 25.3126C37.9832 25.9661 38.513 26.4959 39.1666 26.4959ZM37.1499 25.3126C37.1499 24.1988 38.0528 23.2959 39.1666 23.2959C40.2803 23.2959 41.1832 24.1988 41.1832 25.3126C41.1832 26.4263 40.2803 27.3292 39.1666 27.3292C38.0528 27.3292 37.1499 26.4263 37.1499 25.3126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 27.3873C40.3128 27.3873 41.2418 26.4583 41.2418 25.3123C41.2418 24.1663 40.3128 23.2373 39.1668 23.2373C38.0208 23.2373 37.0918 24.1663 37.0918 25.3123C37.0918 26.4583 38.0208 27.3873 39.1668 27.3873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21625_31262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.7533 137.374) rotate(-124.286) scale(199.872 501.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21625_31262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.677 142.288) rotate(-124.286) scale(209.971 527.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21625_31262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorInfo);
export default __webpack_public_path__ + "static/media/color_info.897a3f871f4e5b5ea00b46bc2b9af363.svg";
export { ForwardRef as ReactComponent };